const baseUrl = process.env.REACT_APP_PAYPAL_BASE_URL;
const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
const redirect_uri = process.env.REACT_APP_PAYPAL_REDIRECT_URI;

export const PAYPAL_LINK = baseUrl+'?flowEntry=static&client_id=' + clientId + '&response_type=code&scope=openid%20https%3A%2F%2Furi.paypal.com%2Fservices%2Fpaypalattributes&redirect_uri=' + redirect_uri

